window.PortalParams = function(bIgnoreHash) {
   var self = this,
      m_oParams = {},
      m_oHashParams = {},
      m_oFinalParams = {};

   this.set = this.setParam = function(sParam, sValue) {
      if (sValue == null) {
         if (m_oParams[sParam]) {
            m_oFinalParams[sParam] = c21Helpers.NULL;
         } else if (m_oHashParams[sParam]) {
            delete m_oFinalParams[sParam];
         }
      } else {
         m_oFinalParams[sParam] = sValue;
      }
   }

   this.remove = this.removeParam = function(sParam) {
      self.setParam(sParam, null);
   }

   this.get = this.getParam = function(sParam) {
      if (sParam) {
         return m_oFinalParams[sParam];
      } else {
         return m_oFinalParams;
      }
   }

   this.getParams = function() {
      return m_oFinalParams;
   }

   this.reload = function() {
      var sUrl = window.location.protocol + "//" + document.location.host + document.location.pathname,
         sQuery = $.param(m_oFinalParams);
      if (sQuery.length > 0) {
         sUrl += '?' + sQuery;
      }

      document.location = sUrl;
   }

   function init() {
      var strHash = portalAjax.getHash(),
         sQuery = document.location.search.substring(1),
         bLid = (sQuery.indexOf("lid") >= 0) ? true : false;

      let m_oSeoParams = RewriteRules.match(document.location.pathname);
      
      m_oParams = c21Helpers.queryToJSON(sQuery);

      if (strHash && !bIgnoreHash) {
         m_oHashParams = c21Helpers.queryToJSON(strHash);
      }

      $.each(m_oSeoParams, function(key, value) {
         m_oFinalParams[key] = value;
         if(key == 'lid') bLid = true;
      });
      
      $.each(m_oParams, function(key, value) {
         m_oFinalParams[key] = value;
         if(key == 'lid') bLid = true;
      });

      $.each(m_oHashParams, function(key, value) {
         m_oFinalParams[key] = value;
         if(key == 'lid') bLid = true;
      });

      if (!bLid) {
         // Look for fallback lid
         var fallback = $("#fallbackLid");
         if(fallback.length){
            m_oFinalParams["lid"] = fallback.val();
         }
      }
   }

   init();
};
